// ============================================
// СЧЁТЧИК ЦИФР (Numbers Animation)
// ============================================

document.addEventListener('DOMContentLoaded', function() {
  const numbersSection = document.querySelector('.numbers');
  const numberElements = document.querySelectorAll('.numbers__value');

  // Флаг, чтобы анимация запускалась только один раз
  let isAnimated = false;

  // Функция анимации
  function animateNumbers() {
    if (isAnimated) return;

    numberElements.forEach(el => {
      const target = parseInt(el.getAttribute('data-count'));
      const duration = 2000; // 2 секунды
      const step = Math.max(1, Math.floor(target / 60));
      let current = 0;

      // Очищаем текст, оставляем только span-ы для символов
      const spanElements = el.querySelectorAll('span');
      let symbol = '';
      if (spanElements.length > 0) {
        symbol = spanElements[0].outerHTML;
      }

      const timer = setInterval(() => {
        current += step;
        if (current >= target) {
          current = target;
          clearInterval(timer);
        }

        // Форматируем число с пробелами для тысяч
        const formatted = current.toLocaleString('ru-RU');

        // Обновляем текст, сохраняя символы
        if (symbol) {
          el.innerHTML = formatted + ' ' + symbol;
        } else {
          el.textContent = formatted;
        }
      }, 30);
    });

    isAnimated = true;
  }

  // Отслеживаем появление блока в поле зрения (Intersection Observer)
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        animateNumbers();
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.3 // 30% блока видно
  });

  if (numbersSection) {
    observer.observe(numbersSection);
  }
});
